import { GoogleSimpleButton } from './GoogleSimpleButton';

type Props = {
  readonly shouldShowGoogle: boolean;
};

export const ExternalLoginProviders = ({ shouldShowGoogle }: Readonly<Props>) =>
  shouldShowGoogle ? <GoogleSimpleButton /> : '';
